'use strict';

module.exports = {
    /**
     * 监听截屏事件，一定要配合 registerScreenshot 接口一起使用，两个 api 先后调用顺序无强制要求<br />
     * 区别：onReceiveScreenshot 用于监听截屏事件，截屏成功后会触发其回调；而 registerScreenshot 是注册截屏事件<br />
     * 对应native接口：onReceiveScreenshot
     * @method hysdk.onReceiveScreenshot
     * @category Device Event
     * @example ./onReceiveScreenshot.js[1-19]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   X   |
     *
     */
    receiveScreenshot: {
        hy: {
            key: 'onReceiveScreenshot'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/events/device.js
// module id = 24
// module chunks = 0 2 4